module.exports = __webpack_public_path__ + "static/media/musicLessons.46ee861b.png";